import { multiply, volatileSum, zero } from "~/utils/PriceUtils";
import { type LineItem } from "~/features/cart/cart/models/CartData";
import { type RootState } from "~/app/store";
import { selectLineItemsByProduct } from "~/features/cart/cart/redux/selectors/cartSelectors";

export const selectTotalTargetPriceForPackage = (entry: LineItem) =>
  multiply(entry.targetPrice || zero(), entry.quantity);

export const selectTargetSubtotal = (state: RootState, productCode: string) => {
  const packEntries = selectLineItemsByProduct(state)[productCode];
  const totalPerPack = packEntries.map(selectTotalTargetPriceForPackage);
  return volatileSum(...totalPerPack);
};
